import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelText as _vModelText, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "incident-form-container" }
const _hoisted_2 = ["open"]
const _hoisted_3 = { class: "dialog-content" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "form-group"
}
const _hoisted_7 = { class: "form-label" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "form-group mt-2" }
const _hoisted_10 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_11 = { class: "row mt-2" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "col" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "form-check" }
const _hoisted_17 = { class: "row mt-3" }
const _hoisted_18 = { class: "form-group col" }
const _hoisted_19 = { class: "form-group col" }
const _hoisted_20 = { class: "form-group mt-2" }
const _hoisted_21 = { class: "form-actions" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }

import { ref, reactive, onMounted, watch, nextTick } from 'vue';
  import { useIncidentStore } from '@/stores/useIncidentStore';
  import { storeToRefs } from 'pinia';
  //import axios from 'axios';
  import _ from 'lodash';
  import entitiesAPI from '@/api/entitiesAPI';
  import usersAPI from '@/api/usersAPI';
  import SearchSelect from './SearchSelect.vue';
  import type { Incident } from '@/types/incidentsTypes';

  type SearchSelectInstance = {
    resetInput: () => void;
    // Agrega otros métodos si los necesitas
  };

  interface Operator {
    id: number | string;
    name: string;
  }
  /* onMounted(async () => {
    try {
      const response = await usersAPI.getOperators();
      console.log("Response:", response.results)
      operators.value = response.results.map((operator: any) => ({
        id: Number(operator.id),
        name: operator.username
      }));
      console.log(operators)
    } catch (error) {
      console.error('Error buscando operadores:', error);
    }
  }); */

  
export default /*@__PURE__*/_defineComponent({
  __name: 'IncidentFormComponent',
  props: {
    show: { type: Boolean },
    incident: {}
  },
  emits: ["close", "submitted"],
  setup(__props: any, { emit: __emit }) {

  const incidentStore = useIncidentStore();
  
  const showDialog = ref(false);
  const submitting = ref(false);
  const operators = ref<Operator[]>([]);

  const expendeduriaInitialValue = ref('');
  const maquinaInitialValue = ref('');
  const expendeduriaSelect = ref<SearchSelectInstance | null>(null);
  const maquinaSelect = ref<SearchSelectInstance | null>(null);

  const props = __props;

  const emit = __emit;
  
  // Eliminar showDialog y usar prop
  watch(() => props.show, (newVal) => {
    if (!newVal) resetForm();
  });

  // Modificar métodos de cierre y envío
  const closeDialog = () => {
    emit('close');
  };


  // Estado del formulario
  const formData = reactive({
    id: null as number | null,
    id_expendeduria: null as number | null,
    id_maquina: null as number | null,
    id_operator: null as number | null,
    client_name: '',
    client_phone: null as number | null,
    is_resolved: false,
    description: ''
  });
  
  // Lista de operadores
  const operatorsLoaded = ref(false);
  const operatorsError = ref(false);
  const loadingOperators = ref(false);

  watch(() => props.show, async (visible) => {
    if (visible) {
      // Solo resetea si NO estamos editando una incidencia existente
      if (!props.incident) {
        resetForm();
      }
      
      // Cargar operadores solo si no se han cargado antes y no hay error
      if (!operatorsLoaded.value && !operatorsError.value && !loadingOperators.value) {
        await loadOperators();
      }

      if (props.incident) {
        await loadIncidentData(props.incident);
      }

      // Solo resetear los inputs si no estamos editando
      await nextTick();
      if (!props.incident) {
        expendeduriaSelect.value?.resetInput();
        maquinaSelect.value?.resetInput();
      }
    }
  });

  // Búsqueda de expendedurías
  const expendeduriasResults = ref<any[]>([]);
  const loadingExpendedurias = ref(false);
  const handleExpendeduriaSearch = _.debounce(async (query: string) => {
    if (query === "") {
      expendeduriasResults.value = [];
      return
    }
    
    try {
      loadingExpendedurias.value = true;
      const response = await entitiesAPI.searchExpendeduria(query);
      expendeduriasResults.value = response.results.slice(0, 10);
    } catch (error) {
      console.error('Error buscando expendedurías:', error);
    } finally {
      loadingExpendedurias.value = false;
    }
  }, 500);
  
  const selectExpendeduria = (item: any) => {
    formData.id_expendeduria = item.id;
  };
  
  // Búsqueda de máquinas
  const maquinasResults = ref<any[]>([]);
  const loadingMaquinas = ref(false);
  const handleMaquinaSearch = _.debounce(async (query: string) => {
    if (!formData.id_expendeduria) {
      maquinasResults.value = [];
      return;
    }

    if (query) {
      formData.id_maquina = null;
    }

    if (query === "") {
      maquinasResults.value = [];
      return
    } 
    try {
      loadingMaquinas.value = true;
      const response = await entitiesAPI.searchMaquina(query, formData.id_expendeduria)
      maquinasResults.value = response.results.slice(0, 10);
    } catch (error) {
      console.error('Error buscando máquinas:', error);
    } finally {
      loadingMaquinas.value = false;
    }
  }, 500);
  
  const selectMaquina = (item: any) => {
    formData.id_maquina = item.id;
  };
  
  // Envío del formulario
  const submitForm = async () => {
    if (!formData.id_operator) {
      alert('Por favor selecciona un operador');
      return;
    }

    submitting.value = true;
    
    try {
      const payload = { ...formData };

      if (formData.id) {
        // modo edición
        await incidentStore.updateIncident(formData.id, payload)
      } else {
        // modo creación
        await incidentStore.createIncident(payload);
      }

      emit('submitted')
      emit('close')
      resetForm();
    } catch (error) {
      console.error('Error creando o editanto incidencia:', error);
      alert('Error al guardar o editar la incidencia');
    } finally {
      submitting.value = false;
    }
  };
  
  const resetForm = () => {
    formData.id = null;
    formData.id_expendeduria = null;
    formData.id_maquina = null;
    formData.id_operator = null;
    formData.client_name = '';
    formData.client_phone = null;
    formData.is_resolved = false;
    formData.description = '';

    expendeduriasResults.value = [];
    maquinasResults.value = [];

    handleExpendeduriaSearch.cancel();
    handleMaquinaSearch.cancel();

    expendeduriaInitialValue.value = "";
    maquinaInitialValue.value = "";
  };

  watch(() => formData.id_operator, (newVal) => {
    console.log('Operador seleccionado:', newVal);
  });


  watch(() => formData.id_expendeduria, (newVal) => {
    if (newVal) {
      formData.id_maquina = null; // Resetear máquina al cambiar expendeduría
      maquinasResults.value = []; // Limpiar resultados anteriores

      const maquinaInput = document.querySelector('.search-select input[placeholder="Buscar máquina..."]') as HTMLInputElement;

      if (maquinaInput) maquinaInput.value = '';
    }
  });

  watch(() => props.show, async (visible) => {
    if (visible) {
      if (!props.incident) {
        resetForm();
      }
      
      if (operators.value.length === 0) {
        await loadOperators();
      }

      if (props.incident) {
        await loadIncidentData(props.incident);
      }

      // Solo resetear los inputs si no estamos editando
      await nextTick();
      if (!props.incident) {
        expendeduriaSelect.value?.resetInput();
        maquinaSelect.value?.resetInput();
      }

      // Limpiar físicamente los inputs
      /* setTimeout(() => {
        const inputs = document.querySelectorAll('.search-select input');
        inputs.forEach(input => (input as HTMLInputElement).value = '');
      }, 50); */
    }
  });

  /* const loadOperators = async () => {
    try {
      const response = await usersAPI.getOperators();
      operators.value = response.results.map((operator: any) => ({
        id: Number(operator.id),
        name: operator.username || 'Sin nombre' // Manejar casos null
      }));
    } catch (error) {
      console.error('Error cargando operadores:', error);
      alert('Error al cargar operadores');
    }
  }; */

  const loadOperators = async () => {
    loadingOperators.value = true;
    try {
      const response = await usersAPI.getOperators();
      operators.value = response.results.map((operator: any) => ({
        id: Number(operator.id),
        name: operator.username || 'Sin nombre'
      }));
      operatorsLoaded.value = true;
      operatorsError.value = false;
    } catch (error) {
      console.error('Error cargando operadores:', error);
      operatorsError.value = true;
    } finally {
      loadingOperators.value = false;
    }
  };


  const loadIncidentData = async (incident: Incident) => {
    console.log("loadIncident:")
    console.log(incident)
    
    formData.id = incident.id;
    formData.id_expendeduria = incident.id_expendeduria;
    formData.id_maquina = incident.id_maquina;
    formData.id_operator = incident.id_operator;
    formData.client_name = incident.client_name;
    formData.client_phone = incident.client_phone;
    formData.is_resolved = incident.is_resolved;
    formData.description = incident.description;

    console.log("formData.id = " + formData.id)

    // Establecer valores iniciales para los campos de búsqueda
    expendeduriaInitialValue.value = incident.expendeduria_name || '';
    maquinaInitialValue.value = incident.maquina_name || '';

    // Cargar máquinas si tenemos expendeduría
    if (incident.id_expendeduria) {
      try {
        loadingMaquinas.value = true;
        const response = await entitiesAPI.searchMaquina("", incident.id_expendeduria);
        maquinasResults.value = response.results;
      } catch (error) {
        console.error("Error cargando máquinas", error);
      } finally {
        loadingMaquinas.value = false;
      }
    }

    // Forzar la actualización de los componentes SearchSelect
    /* await nextTick();
    if (expendeduriaSelect.value) {
      expendeduriaSelect.value.resetInput();
    }
    if (maquinaSelect.value) {
      maquinaSelect.value.resetInput();
    } */
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("dialog", {
      open: _ctx.show,
      class: "incident-dialog"
    }, [
      _createElementVNode("div", _hoisted_3, [
        (formData.id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[5] || (_cache[5] = [
              _createElementVNode("h2", null, "Editar Incidencia", -1)
            ])))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[6] || (_cache[6] = [
              _createElementVNode("h2", null, "Nueva Incidencia", -1)
            ]))),
        _createElementVNode("form", {
          onSubmit: _withModifiers(submitForm, ["prevent"])
        }, [
          (formData.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("label", _hoisted_7, "ID: " + _toDisplayString(formData.id), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _cache[7] || (_cache[7] = _createElementVNode("label", { class: "form-label" }, "Expendeduría:", -1)),
            _createVNode(SearchSelect, {
              "reset-trigger": !_ctx.show,
              items: expendeduriasResults.value,
              loading: loadingExpendedurias.value,
              "initial-value": expendeduriaInitialValue.value,
              "item-text": "name",
              onSearch: _unref(handleExpendeduriaSearch),
              onSelect: selectExpendeduria,
              placeholder: "Buscar expendeduría...",
              ref_key: "expendeduriaSelect",
              ref: expendeduriaSelect
            }, null, 8, ["reset-trigger", "items", "loading", "initial-value", "onSearch"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[8] || (_cache[8] = _createElementVNode("label", { class: "form-label" }, "Máquina:", -1)),
            (_openBlock(), _createBlock(SearchSelect, {
              items: maquinasResults.value,
              loading: loadingMaquinas.value,
              disabled: !formData.id_expendeduria,
              "initial-value": maquinaInitialValue.value,
              "item-text": "name",
              onSearch: _unref(handleMaquinaSearch),
              onSelect: selectMaquina,
              placeholder: "Buscar máquina...",
              key: `maquina-select-${formData.id_expendeduria}`,
              ref_key: "maquinaSelect",
              ref: maquinaSelect
            }, null, 8, ["items", "loading", "disabled", "initial-value", "onSearch"])),
            (!formData.id_expendeduria)
              ? (_openBlock(), _createElementBlock("small", _hoisted_10, " ⚠️ Seleccione primero una expendeduría "))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _cache[9] || (_cache[9] = _createElementVNode("label", { class: "form-label" }, "Operador:", -1)),
              _withDirectives(_createElementVNode("select", {
                class: "form-select form-select-sm p-1",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.id_operator) = $event)),
                required: ""
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(operators.value, (operator) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: operator.id,
                    value: operator.id
                  }, _toDisplayString(operator.name), 9, _hoisted_13))
                }), 128))
              ], 512), [
                [_vModelSelect, formData.id_operator]
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "row" }, [
                _createElementVNode("div", { class: "form-label" }, " Estado: ")
              ], -1)),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    value: "",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.is_resolved) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, formData.is_resolved]
                  ]),
                  _cache[10] || (_cache[10] = _createElementVNode("label", { class: "form-check-label" }, " Incidencia resuelta ", -1))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _cache[12] || (_cache[12] = _createElementVNode("label", null, "Nombre del cliente (opcional):", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.client_name) = $event)),
                type: "text",
                maxlength: "255"
              }, null, 512), [
                [_vModelText, formData.client_name]
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _cache[13] || (_cache[13] = _createElementVNode("label", null, "Teléfono del cliente (opcional):", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.client_phone) = $event)),
                type: "tel",
                pattern: "[0-9]{9,15}",
                placeholder: "Ej: 654968918"
              }, null, 512), [
                [_vModelText, formData.client_phone]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _cache[14] || (_cache[14] = _createElementVNode("label", { class: "form-label" }, "Descripción:", -1)),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.description) = $event)),
              required: "",
              rows: "4"
            }, null, 512), [
              [_vModelText, formData.description]
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("button", {
              type: "button",
              onClick: closeDialog,
              class: "cancel-btn"
            }, " Cancelar "),
            _createElementVNode("button", {
              type: "submit",
              disabled: submitting.value,
              class: "btn btn-dark"
            }, [
              (submitting.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_23, "Guardando..."))
                : (_openBlock(), _createElementBlock("span", _hoisted_24, "Guardar Incidencia"))
            ], 8, _hoisted_22)
          ])
        ], 32)
      ])
    ], 8, _hoisted_2)
  ]))
}
}

})